export function get_option_product1(data) {
    let option = {
        title: {
            top: "3",
            left: "center",
            text: "近3年的月度电费趋势图",
            subtext: ""
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: ['电费'],
            top: 60
        },
        grid: {
            top: 90,
            show: true
        },
        toolbox: {
            feature: {
                dataView: {
                    show: true,
                    readOnly: false
                },
                magicType: {
                    show: true,
                    type: ['line', 'bar']
                },
                restore: {
                    show: true
                },
                saveAsImage: {}
            }
        },

        dataset: [{
            source: data
        }],
        xAxis: {
            type: 'category',
            boundaryGap: false
        },
        yAxis: [{
                type: 'value',
                name: '金额(元)',
                nameLocation: "middle",
                nameGap: 50
            },

        ],
        series: [{
                name: '电费',
                type: 'line',
                smooth: true,
                encode: {
                    x: 'ym',
                    y: 'jshj'
                }
            },
            // {
            //     name: 'N₂O',
            //     type: 'line',
            //     smooth: true,
            //     encode: {
            //         x: 'time_of_data',
            //         y: 'N2O'
            //     },
            //     yAxisIndex: 1,
            // },

        ]
    };
    return option;
}


export function get_option_product2(data) {
    let option = {
        title: {
            top: "3",
            left: "center",
            text: "近3年的月度运费趋势图",
            subtext: ""
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: ['运费'],
            top: 60
        },
        grid: {
            top: 90,
            show: true
        },
        toolbox: {
            feature: {
                dataView: {
                    show: true,
                    readOnly: false
                },
                magicType: {
                    show: true,
                    type: ['line', 'bar']
                },
                restore: {
                    show: true
                },
                saveAsImage: {}
            }
        },

        dataset: [{
            source: data
        }],
        xAxis: {
            type: 'category',
            boundaryGap: false
        },
        yAxis: [{
                type: 'value',
                name: '金额(元)',
                nameLocation: "middle",
                nameGap: 50
            },

        ],
        series: [{
                name: '运费',
                type: 'line',
                smooth: true,
                encode: {
                    x: 'ym',
                    y: 'jshj'
                }
            },
            // {
            //     name: 'N₂O',
            //     type: 'line',
            //     smooth: true,
            //     encode: {
            //         x: 'time_of_data',
            //         y: 'N2O'
            //     },
            //     yAxisIndex: 1,
            // },

        ]
    };
    return option;
}


export function get_option_shuifei(data) {
    let option = {
        title: {
            top: "3",
            left: "center",
            text: "近3年的月度水费趋势图",
            subtext: ""
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: ['水费'],
            top: 60
        },
        grid: {
            top: 90,
            show: true
        },
        toolbox: {
            feature: {
                dataView: {
                    show: true,
                    readOnly: false
                },
                magicType: {
                    show: true,
                    type: ['line', 'bar']
                },
                restore: {
                    show: true
                },
                saveAsImage: {}
            }
        },

        dataset: [{
            source: data
        }],
        xAxis: {
            type: 'category',
            boundaryGap: false
        },
        yAxis: [{
                type: 'value',
                name: '金额(元)',
                nameLocation: "middle",
                nameGap: 50
            },

        ],
        series: [{
                name: '水费',
                type: 'line',
                smooth: true,
                encode: {
                    x: 'ym',
                    y: 'jshj'
                }
            },
            // {
            //     name: 'N₂O',
            //     type: 'line',
            //     smooth: true,
            //     encode: {
            //         x: 'time_of_data',
            //         y: 'N2O'
            //     },
            //     yAxisIndex: 1,
            // },

        ]
    };
    return option;
}

